import { ChangeDetectionStrategy, Component, EventEmitter, input, InputSignal, Output } from '@angular/core';
import { SzHfGridLayout, SzHfTime, SzHfZone, SzHfZoneKey } from './sz-hf-grid.types';

@Component({
  selector: 'sz-hf-grid',
  templateUrl: './sz-hf-grid.component.html',
  styleUrls: ['./sz-hf-grid.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true
})
export class SzHfGridComponent {
  readonly zones: InputSignal<ReadonlyArray<SzHfZone>> = input.required<ReadonlyArray<SzHfZone>>();
  readonly disabled: InputSignal<boolean> = input<boolean>(false);
  readonly layout: InputSignal<SzHfGridLayout> = input<SzHfGridLayout>('row');
  readonly time: InputSignal<SzHfTime | null> = input<SzHfTime | null>(null);

  @Output() readonly zoneClick: EventEmitter<SzHfZoneKey> = new EventEmitter<SzHfZoneKey>();
  @Output() readonly timeClick: EventEmitter<void> = new EventEmitter<void>();

  isBad(key: SzHfZoneKey): boolean {
    return key === 'M' || key === 'NS';
  }

  onClick(key: SzHfZoneKey): void {
    if (this.disabled()) {
      return;
    }
    this.zoneClick.emit(key);
  }

  onTimeClick(): void {
    if (this.disabled()) {
      return;
    }
    this.timeClick.emit();
  }
}
